import { render, staticRenderFns } from "./ListLayout.vue?vue&type=template&id=2a1579ae&"
import script from "./ListLayout.vue?vue&type=script&lang=ts&"
export * from "./ListLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ListLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports